import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import moment from "moment";
import ExcellentExport from "excellentexport";
import Cookies from "js-cookie";
import ReactToPrint from "react-to-print";

import {
  Col,
  Row,
  Form,
  Button,
  Dropdown,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

import {
  GetClassesAttendance,
  DeleteStudentClass,
  GetClassDays,
  GetNonWorkingDays,
} from "../../api/class";

import ModalConfirmDelete from "../global/modals/ModalConfirmDelete";
import ModalConfirmAttendance from "./modals/ModalConfirmAttendance";
import ModalAssistanceCategories from "./modals/ModalAssistanceCategories";
import { getFullName } from "../global/GlobalTools";

//cambiar el idioma de moment
const prefix = process.env.REACT_APP_PREFIX;
const language = localStorage.getItem(`cmLanguage${prefix}`);
moment.locale(language == "english" ? "en" : "es");

const todayFormat = moment().format("ddd-DD");

const daysKey = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const customStyles = {
  headerRow: {
    position: "sticky",
    top: 0,
    background: "#fff",
    zIndex: 2,
  },
  headerNameCell: {
    border: "1px solid #dee2e6",
    background: "#fff",
    width: "30%",
  },
  headerCatCell: {
    border: "1px solid #dee2e6",
    background: "#fff",
    width: "20px",
  },
  headerCell: {
    border: "1px solid #dee2e6",
    background: "#fff",
  },

  nameCell: {
    borderLeft: "1px solid #dee2e6",
    borderRight: "1px solid #dee2e6",
    width: "30%",
    background: "#fff",
  },

  iconGear: {
    fontSize: "16px",
    marginLeft: "8px",
    cursor: "pointer",
  },

  td: {
    borderBottom: "1px solid #dee2e6",
  },
  tdCategories: {
    borderBottom: "1px solid #dee2e6",
    padding: "0",
  },

  iconStudent: {
    alignContent: "center",
    fontSize: "17px",
    color: "var(--red-primary)",
    cursor: "pointer",
  },

  iconRemoveX: {
    alignContent: "center",
    fontSize: "17px",
    color: "#b8bcbd",
    cursor: "pointer",
    marginTop: "-5px",
  },
  lazyLabel: {
    height: "17px",
    width: "60%",
  },
  lazyLabelCell: {
    height: "17px",
    width: "12%",
    display: "inline-block",
    marginRight: "5px",
    marginLeft: "5px",
  },
};

// Función para poner la primera letra en mayúscula
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// dimensiones de la pantalla
const screenHeight = window.innerHeight;
const containerHeight = screenHeight - 320;

const ClassAttendance = (props) => {
  const [t] = useTranslation(["class", "global"]);
  const [attendanceData, setAttendanceData] = useState(null);
  const [studentList, setStudentList] = useState([]);
  const [currentWeekDate, setCurrentWeekDate] = useState([]);
  const [weekDateFilter, setWeekDateFilter] = useState(moment());
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [studentToDelete, setStudentToDelete] = useState(null);
  const [updatingList, setUpdatingList] = useState(true);
  const [showModalAssistanceCategories, setShowModalAssistanceCategories] =
    useState(false);
  const [categoriesAttendance, setCategoriesAttendance] = useState([]);
  const [attendanceToConfirmed, setAttendanceToConfirmed] = useState([]);
  const [showModalConfirmAttendance, setShowModalConfirmAttendance] =
    useState(false);
  const [classDays, setClassDays] = useState([]);
  const [changesDetected, setChangesDetected] = useState(false);
  const [nonWorkingDays, setNonWorkingDays] = useState([]);

  useEffect(() => {
    getNonWorkingDays();
    getClassDays();

    getAttendance();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (Cookies.get("refreshAttendance") === "true") {
        getClassDays();
        getAttendance();
        Cookies.remove("refreshAttendance");
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (props.refreshStudentList) {
      getAttendance();
      props.setRefreshStudentList(false);
    }
  }, [props.refreshStudentList]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    if (changesDetected) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    } else {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [changesDetected]);

  const getNonWorkingDays = () => {
    const payload = {
      class_id: props.classId,
    };
    GetNonWorkingDays(payload).then((result) => {
      if (result.status) {
        const nonWorkingSet = new Set();
        const data = result.data || [];
        const rangeAbsencePerDay = data.map((day) => ({
          startDate: moment.unix(day.start_time).format("DD-MM-YYYY"),
          endDate: moment.unix(day.end_time).format("DD-MM-YYYY"),
        }));
        // fill in the set with the disabled days
        rangeAbsencePerDay.forEach((day) => {
          let current = moment(day.startDate, "DD-MM-YYYY");
          const end = moment(day.endDate, "DD-MM-YYYY");
          while (current.isSameOrBefore(end)) {
            nonWorkingSet.add(current.format("DD-MM-YYYY"));
            current.add(1, "days");
          }
        });
        setNonWorkingDays(nonWorkingSet);
        weekLabel(moment(), nonWorkingSet);
      }
    });
  };

  const getClassDays = () => {
    const payload = {
      class_id: props.classId,
    };
    GetClassDays(payload).then((result) => {
      if (result.status) {
        const daysActive = {
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
        };
        let scheduleList = result.data.schedule;

        for (const schedule of scheduleList) {
          for (const key of daysKey) {
            if (schedule[key]) {
              daysActive[key] = true;
            }
          }
        }
        setClassDays(daysActive);
      }
    });
  };

  const getAttendance = (newDate = false) => {
    setUpdatingList(true);
    const payload = {
      class_id: props.classId,
      date: newDate ? newDate.unix() : weekDateFilter.unix(),
    };
    GetClassesAttendance(payload)
      .then((response) => {
        if (response.status) {
          const students = response.data.students || [];
          const defaultCategoryName = t("class:attendance.classAttendance");
          for (let student of students) {
            student.fullName = getFullName(student, true);
            student.category_attendance = student.category_attendance
              .slice() // shallow copy to avoid mutating original array
              .sort((a, b) => {
                if (a.flag == 1) return -1;
                if (b.flag == 1) return 1;
                if (a.id == 1) return -1;
                if (b.id == 1) return 1;
                return 0;
              })
              .map((category) => {
                const isDefaultCategory =
                  category.id == 1 || category.flag == 1;
                return {
                  ...category,
                  name: isDefaultCategory ? defaultCategoryName : category.name,
                };
              });
          }
          setAttendanceData(students);
          props.setCurrentStudents(students);
          setStudentList(students || []);
          props.setStudentsCount(students.length);
          if (students.length) extractAttendanceCategories(students);
        }
        setUpdatingList(false);
      })
      .catch(() => {});
  };

  const extractAttendanceCategories = (students) => {
    const studentAttCat = [...students[0]?.category_attendance] || [];

    const categories = studentAttCat.map((cat) => ({
      id: parseInt(cat.id),
      class_id: parseInt(cat.class_id),
      name: cat.name,
      color: cat.color,
      input_type: cat.input_type,
      flag: cat.flag,
      daysWeek: sortDaysWeek(cat.days_of_the_week),
      colorPiker: false,
    }));
    setCategoriesAttendance(categories);
    formatCategoryForAttendance([...categories]);
  };

  const formatCategoryForAttendance = (categories) => {
    const categoriesFormat = categories.map((cat) => ({
      id: cat.id,
      name: cat.name,
      color: cat.color,
      type: cat.input_type,
      attendancesDays: [],
    }));
    setAttendanceToConfirmed(categoriesFormat);
  };

  const sortDaysWeek = (daysOfTheWeek) => {
    const orden = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];
    const daysOrdered = orden.map((dia) => ({
      day: dia,
      value: daysOfTheWeek[dia],
    }));

    return daysOrdered;
  };

  const addNewStudent = () => {
    const students = studentList.map((student) => ({
      id: student.id,
      name: student.last_name + " " + student.first_name,
    }));
    props.classId == "new"
      ? props.setFieldStudents(students)
      : props.setCurrentStudents(students);
    props.setShowModalAddStudents(true);
  };

  const weekLabel = (date = moment(), nonWorking = nonWorkingDays) => {
    const week = [];
    const weekFormat = [];
    let date_unix = moment(date).unix();
    let current = moment.unix(date_unix);
    if (current.day() == 0) {
      //En los casos en que es domingo, restar como si fuera septimo dia y no cero
      current.set("day", current.day() - 7 + 1);
    } else {
      current.set("day", current.day() - current.day() + 1);
    }

    //largo de la semana
    const weekLength = 7;
    for (let i = 0; i < weekLength; i++) {
      week.push(new Date(current));
      current.set("day", current.day() + 1);
    }
    let countDaysKey = 0;
    week.forEach((w) => {
      weekFormat.push({
        name: daysKey[countDaysKey],
        label: moment(w).format("ddd-DD"),
        fullDate: moment(w).format("DD-MM-YYYY"),
        nonWorking: nonWorking.has(moment(w).format("DD-MM-YYYY")),
      });
      countDaysKey += 1;
    });
    setCurrentWeekDate(weekFormat);
  };

  const changeMonth = (direction) => {
    let newDate = moment(weekDateFilter);
    if (direction === "next") {
      newDate.add(1, "month");
    } else {
      newDate.subtract(1, "month");
    }
    weekLabel(newDate);
    setWeekDateFilter(newDate);
    getAttendance(newDate);
  };

  const changeWeek = (direction) => {
    let newDate = moment(weekDateFilter);
    if (direction === "next") {
      newDate.add(1, "week");
    } else {
      newDate.subtract(1, "week");
    }
    weekLabel(newDate);
    setWeekDateFilter(newDate);
    getAttendance(newDate);
  };

  const localStudentFilter = (text) => {
    const filteredStudents = attendanceData.filter((student) => {
      const fullName =
        student.first_name.toLowerCase() +
        " " +
        student.last_name.toLowerCase();
      return fullName.includes(text.toLowerCase());
    });
    setStudentList(filteredStudents);
  };

  const removeStudent = () => {
    const payload = {
      student_id: studentToDelete,
      class_id: props.classId,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    DeleteStudentClass(payload).then(() => {
      getAttendance();
    });
  };

  const lazyLoadingStudentsList = () => {
    const studentCount = studentList.length || 10;
    const arrayLazy = Array.from({ length: studentCount }, (_, i) => ({
      id: i,
      loading: true,
    }));

    return arrayLazy.map((item, index) => (
      <tr className="table-lazyLoading" key={index}>
        <td style={customStyles.td}>
          <div>
            <div style={customStyles.lazyLabel}></div>
          </div>
        </td>
        <td style={customStyles.tdCategories}></td>
        <td
          style={{ ...customStyles.td, verticalAlign: "middle" }}
          className="px-0 py-0"
        >
          <div>
            {[1, 2, 3, 4, 5, 6, 7].map((item, index) => (
              <div key={index} style={customStyles.lazyLabelCell}></div>
            ))}
          </div>
        </td>
      </tr>
    ));
  };

  const toolBar = () => {
    return (
      <Row>
        <Col sm={12} md={12} lg={12} xl={3} xxl={3} className="mb-lg-2 mb-xl-0">
          <Form.Control
            type="text"
            placeholder={t("class:attendance.searchStudent")}
            name="searchStudent"
            id="searchStudent"
            onChange={(e) => localStudentFilter(e.target.value)}
          />
        </Col>
        <Col
          sm={12}
          md={12}
          lg={12}
          xl={9}
          xxl={9}
          style={{ alignContent: "center" }}
        >
          {/* btn attendance Categories */}
          <Button
            id="btnAssistanceCategories"
            className="float-end"
            variant="outline-secondary"
            onClick={() => setShowModalAssistanceCategories(true)}
            disabled={categoriesAttendance.length == 0}
          >
            {t("class:attendance.categoriesOfAssistance")}
            <i
              className="bi bi-gear float-end"
              style={customStyles.iconGear}
              id={"addStudent"}
              role="button"
            />
          </Button>
          <Dropdown className="float-end me-2">
            <Dropdown.Toggle
              className="text-truncate"
              id="dropdownTableAttendance"
              variant="outline-secondary"
              disabled={studentList.length == 0}
            >
              <i className="bi bi-file-spreadsheet me-2" />
              {t("global:buttons.table")}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ zIndex: 3 }}>
              <ReactToPrint
                trigger={() => (
                  <Dropdown.Item>
                    {t("global:buttons.downloadPDF")}
                  </Dropdown.Item>
                )}
                content={() => document.getElementById("tableAttendance")}
              />

              <Dropdown.Item
                onClick={() => {
                  downloadExcel();
                }}
              >
                {t("global:buttons.downloadExcel")}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {/* btn Confirm Attendance */}
          <Button
            id="btnConfirmAttendance"
            className="float-end me-2"
            onClick={() => handleToggleConfirmAttendance()}
            disabled={!changesDetected}
          >
            {t("class:attendance.confirmAttendance")}
          </Button>
        </Col>
      </Row>
    );
  };

  const headersTable = () => {
    return (
      <tr style={customStyles.headerRow}>
        <td style={customStyles.headerNameCell}>
          <b>{t("class:attendance.studentsName")}</b>
          <i
            id="addStudent"
            className="bi bi-plus-circle-fill float-end hide-print"
            style={customStyles.iconStudent}
            onClick={() => addNewStudent()}
          ></i>
        </td>
        <td style={customStyles.headerCatCell}></td>
        <td style={customStyles.headerCell} className="px-0 pb-0">
          <tr
            id={"attendaceRowbase"}
            style={{
              textAlign: "center",
              width: "100%",
              display: "table",
              borderBottom: "solid 1px #dee2e6",
            }}
          >
            <i
              className="bi bi-chevron-left me-3 hide-print"
              role="button"
              onClick={() => changeMonth("prev")}
            ></i>
            <b>{weekDateFilter.format("MMMM, YYYY").toUpperCase()}</b>
            <i
              className="bi bi-chevron-right ms-3 hide-print"
              role="button"
              onClick={() => changeMonth("next")}
            ></i>
          </tr>
          <tr
            style={{
              textAlign: "center",
              width: "100%",
              display: "table",
            }}
          >
            <td className="hide-print">
              <i
                className="bi bi-chevron-left"
                role="button"
                onClick={() => changeWeek("prev")}
              ></i>
            </td>
            {currentWeekDate.map((day, index) => (
              <td
                key={index}
                style={
                  day.label === todayFormat ? { background: "#ffd9e0" } : {}
                }
              >
                <b>{day.label.toUpperCase()} </b>
              </td>
            ))}
            <td className="hide-print">
              <i
                className="bi bi-chevron-right"
                role="button"
                onClick={() => changeWeek("next")}
              ></i>
            </td>
          </tr>
        </td>
      </tr>
    );
  };

  const categoriesPerStudent = (categoryAttendance) => {
    /**
     * 21 height para categoria multiple
     * 42 height para categoria unica
     */
    const heightCat = categoryAttendance.length > 1 ? 21 : 42;
    return categoryAttendance.map((category, index) => {
      return (
        <span key={index}>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-group">{category.name}</Tooltip>}
          >
            <div
              id="categoryAssistanceItem"
              style={{
                height: heightCat + "px",
                background: category.color ? "#" + category.color : "gray",
                alignContent: "center",
                textAlign: "center",
              }}
            >
              {category.id == 1
                ? language === "spanish"
                  ? "C"
                  : "A"
                : category.name.substr(0, 1)}
            </div>
          </OverlayTrigger>
        </span>
      );
    });
  };

  const getDisabledDay = (day, atendance) => {
    if (day.nonWorking) {
      return true;
    }
    // If the day is not a class day, disable
    if (!classDays[day.name]) {
      return true;
    }
    // If the day is after today, disable
    if (moment(day.fullDate, "DD-MM-YYYY").isAfter(moment(), "day")) {
      return true;
    }
    // If the day is today, enable
    if (moment(day.fullDate, "DD-MM-YYYY").isSame(moment(), "day")) {
      return false;
    }
    // If attendance is confirmed, disable
    if (atendance && atendance.confirmed_attendances == 1) {
      return true;
    }
    return false;
  };

  const downloadExcel = () => {
    let values = [];

    let row_titles = [
      language == "spanish" ? "Nombre del estudiante" : "Student's name",
      language == "spanish"
        ? "Categorías de asistencia"
        : "Attendance categories",
    ];
    //forEach para agregar los dias de la semana
    currentWeekDate.forEach((day) => row_titles.push(day.label.toUpperCase()));
    //Insert heads
    values.push(row_titles);
    //Create an empty line after the headers
    let redLine = [
      new Array(9).forEach(() => {
        return "";
      }),
    ];
    values.push(redLine);
    studentList.forEach((student) => {
      const categories = student.category_attendance;
      for (let pos in categories) {
        let student_row = [];
        let attended = language == "spanish" ? "Si" : "Yes";
        //------------------TODO: corregir, no esta ordenado
        if (pos == 0) {
          student_row = [
            student.first_name + " " + student.last_name,
            language == "spanish" ? "ASISTENCIA A CLASE" : "CLASS ATTENDANCE",
          ];
          let attendance = categories[pos].attendance;
          for (let day of currentWeekDate) {
            const attenDay = attendance.find((att) => {
              return moment(att.date).format("ddd-DD") === day.label;
            });
            if (attenDay) {
              let value =
                categories[pos].input_type == "checkbox"
                  ? attenDay.value == 1
                    ? attended
                    : "No"
                  : attenDay.value;
              student_row.push(value);
            } else {
              student_row.push("");
            }
          }
        } else {
          student_row.push("");
          student_row.push(categories[pos].name);
          let attendance = categories[pos].attendance;
          for (let day of currentWeekDate) {
            const attenDay = attendance.find((att) => {
              return moment(att.date).format("ddd-DD") === day.label;
            });
            if (attenDay) {
              let value =
                categories[pos].input_type == "checkbox"
                  ? attenDay.value == 1
                    ? attended
                    : "No"
                  : attenDay.value;
              student_row.push(value);
            } else {
              student_row.push("");
            }
          }
        }
        //------------------
        values.push(student_row);
      }
    });

    // create the document
    let options = {
      openAsDownload: true,
      format: "xlsx", //'xlsx' or 'xls' or 'csv'
      //   filename: "Asistencias" + "-" + this.state.class_info.subject.name,
      filename: "Asistencias",
    };
    let data = [
      {
        name: weekDateFilter.format("MMMM, YYYY").toUpperCase(), // Sheet name
        from: {
          array: values, // arrangement of arrangements
        },
        rtl: true,
      },
    ];
    ExcellentExport.convert(options, data);
  };

  const handleToggleConfirmAttendance = () => {
    // const attendance = [];
    // setAttendanceToConfirmed(attendance);
    setShowModalConfirmAttendance(true);
  };

  /**
   * Maneja la asistencia de un estudiante en una categoria y dia especifico
   */
  const handleAttendance = (studentIndex, categoryIndex, dayLabel, value, dayFullDate) => {
    let attendanceToConfirmedUpdated = [...attendanceToConfirmed];
    const student = studentList[studentIndex];
    const studentFormat = {
      id: student.id,
      first_name: student.first_name,
      last_name: student.last_name,
      value: 0,
    };
    const category = student.category_attendance[categoryIndex];
    setChangesDetected(true);
    // busca la caegoria en attendanceToConfirmed
    const existingCategoryIndex = attendanceToConfirmedUpdated.findIndex(
      (entry) => entry.id == category.id,
    );

    if (existingCategoryIndex !== -1) {
      let categoryConfirm = attendanceToConfirmedUpdated[existingCategoryIndex];
      // la categoria tiene attendancesDays? si no la crea
      if (!categoryConfirm.attendancesDays) {
        categoryConfirm.attendancesDays = [];
      }
      // buscar si el dia ya existe
      const existingDayIndex = categoryConfirm.attendancesDays.findIndex(
        (day) => day.date === dayLabel,
      );
      // Construir lista de inasistentes confirmados (confirmed_attendances == 1 y value == 0)
      const confirmedAbsents = studentList
        .map((std) => {
          const att = std.category_attendance[categoryIndex].attendance.find(
            (a) => moment(a.date, "YYYY-MM-DD").format("ddd-DD") === dayLabel,
          );
          if (att && att.confirmed_attendances == 1 && att.value == 0) {
            return {
              id: std.id,
              first_name: std.first_name,
              last_name: std.last_name,
              value: 0,
            };
          }
          return null;
        })
        .filter(Boolean);

      if (existingDayIndex !== -1) {
        // obtener el array de estudiantes para el día
        let studentsArr =
          categoryConfirm.attendancesDays[existingDayIndex].students;
        // Remover duplicados por id
        studentsArr = studentsArr.filter(
          (s) => !confirmedAbsents.some((c) => c.id === s.id),
        );
        // Agregar todos los confirmados ausentes
        studentsArr = [...studentsArr, ...confirmedAbsents];

        // Ahora, aplicar la acción del usuario
        const existingStudentIndex = studentsArr.findIndex(
          (std) => std.id === student.id,
        );
        if (value) {
          // Si se marca asistencia (1), remover al estudiante del array si existe
          if (existingStudentIndex !== -1) {
            studentsArr.splice(existingStudentIndex, 1);
          }
        } else {
          // Si se marca inasistencia (0), agregar o actualizar el estudiante
          if (existingStudentIndex !== -1) {
            studentsArr[existingStudentIndex] = studentFormat;
          } else {
            studentsArr.push(studentFormat);
          }
        }
        categoryConfirm.attendancesDays[existingDayIndex].students =
          studentsArr;
        attendanceToConfirmedUpdated[existingCategoryIndex] = categoryConfirm;
      } else {
        // dia no existe, crearlo
        let studentsArr = [...confirmedAbsents];
        if (!value) {
          // Si el usuario marca inasistencia, agregarlo si no está
          if (!studentsArr.some((s) => s.id === student.id)) {
            studentsArr.push(studentFormat);
          }
        }
        categoryConfirm.attendancesDays.push({
          dateUnix: moment(dayFullDate, "DD-MM-YYYY").startOf("day").unix(),
          date: dayLabel,
          dateDay: capitalizeFirstLetter(
            moment(dayFullDate, "DD-MM-YYYY").format("dddd DD-MM-YYYY"),
          ),
          students: studentsArr,
        });
        attendanceToConfirmedUpdated[existingCategoryIndex] = categoryConfirm;
      }
      setAttendanceToConfirmed(attendanceToConfirmedUpdated);
    }
  };

  const changeTextAttendance = (
    studentIndex,
    categoryIndex,
    dayLabel,
    text,
    dayFullDate,
  ) => {
    setChangesDetected(true);
    let attendanceToConfirmedUpdated = [...attendanceToConfirmed];
    const student = studentList[studentIndex];
    const studentFormat = {
      id: student.id,
      first_name: student.first_name,
      last_name: student.last_name,
      value: text,
    };
    const category = student.category_attendance[categoryIndex];
    // busca la caegoria en attendanceToConfirmed
    const existingCategoryIndex = attendanceToConfirmedUpdated.findIndex(
      (entry) => entry.id == category.id,
    );

    if (existingCategoryIndex !== -1) {
      let categoryConfirm = attendanceToConfirmedUpdated[existingCategoryIndex];
      // la categoria tiene attendancesDays? si no la crea
      if (!categoryConfirm.attendancesDays) {
        categoryConfirm.attendancesDays = [];
      } else {
        // buscar si el dia ya existe
        const existingDayIndex = categoryConfirm.attendancesDays.findIndex(
          (day) => day.date === dayLabel,
        );
        if (existingDayIndex !== -1) {
          // dia ya existe, modificar el valor
          // si el estudiante ya existe en el dia, sobre escribir su valor
          const existingStudentIndex = categoryConfirm.attendancesDays[
            existingDayIndex
          ].students.findIndex((std) => std.id === student.id);
          if (existingStudentIndex !== -1) {
            // si value es vacio eliminar estudiante
            if (text === "") {
              categoryConfirm.attendancesDays[existingDayIndex].students.splice(
                existingStudentIndex,
                1,
              );
            } else {
              categoryConfirm.attendancesDays[existingDayIndex].students[
                existingStudentIndex
              ] = studentFormat;
            }
          } else {
            categoryConfirm.attendancesDays[existingDayIndex].students.push(
              studentFormat,
            );
          }
          attendanceToConfirmedUpdated[existingCategoryIndex] = categoryConfirm;
        } else {
          // dia no existe, agregar nuevo dia
          categoryConfirm.attendancesDays.push({
            dateUnix: moment(dayFullDate, "DD-MM-YYYY").startOf("day").unix(),
            date: dayLabel,
            dateDay: capitalizeFirstLetter(
              moment(dayFullDate, "DD-MM-YYYY").format("dddd DD-MM-YYYY"),
            ),
            students: [studentFormat],
          });
          attendanceToConfirmedUpdated[existingCategoryIndex] = categoryConfirm;
        }
      }
      setAttendanceToConfirmed(attendanceToConfirmedUpdated);
    }
  };

  return (
    <React.Fragment>
      <Col md={12}>
        <div style={{}}>
          <Col
            md={12}
            className="px-2 py-2"
            style={{ border: "solid 1px #dee2e6 " }}
          >
            {toolBar()}
          </Col>
        </div>
        {/* TODO: especificar altura basado en pantalla */}
        <div style={{ maxHeight: containerHeight, overflowY: "auto" }}>
          <table
            id="tableAttendance"
            className="table table-bordered"
            style={{ borderCollapse: "separate", borderSpacing: "0 0px" }}
          >
            <tbody>
              {/* Headers  */}
              {headersTable()}
              {/* Listado de estudiantes con asistencia */}
              {!updatingList &&
                studentList.map((student, stdIndex) => {
                  return (
                    <tr key={stdIndex}>
                      <td
                        style={{ ...customStyles.td, verticalAlign: "middle" }}
                      >
                        <div
                          style={{
                            width: "90%",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            display: "inline-block",
                          }}
                        >
                          {student.fullName}
                        </div>
                        <i
                          className="bi bi-x-circle-fill float-end hide-print"
                          style={customStyles.iconRemoveX}
                          id={"removeStudent-" + stdIndex}
                          role="button"
                          onClick={() => {
                            setShowModalDelete(true);
                            setStudentToDelete(student.id);
                          }}
                        ></i>
                      </td>
                      {/* categorias del estudiante */}
                      <td style={customStyles.tdCategories}>
                        {categoriesPerStudent(student.category_attendance)}
                      </td>
                      {/* calificaciones */}
                      <td
                        style={{ ...customStyles.td, verticalAlign: "middle" }}
                        className="px-0 py-0"
                      >
                        <table
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <tbody>
                            {student.category_attendance.map(
                              (category, catIndex) => {
                                return (
                                  <tr key={catIndex}>
                                    <td width="4%" className="hide-print">
                                      {/* icono oculto para alinear */}
                                      <i
                                        className="bi bi-chevron-left"
                                        style={{ color: "white" }}
                                      ></i>
                                    </td>
                                    {currentWeekDate.map((day, dayIndex) => {
                                      const isToday = day.label === todayFormat;
                                      const isPastDay = moment(
                                        day.fullDate,
                                        "DD-MM-YYYY",
                                      ).isBefore(moment());
                                      const isAfterToday = moment(
                                        day.fullDate,
                                        "DD-MM-YYYY",
                                      ).isAfter(moment());

                                      const atendance =
                                        category.attendance.find((att) => {
                                          return (
                                            moment(
                                              att.date,
                                              "YYYY-MM-DD",
                                            ).format("DD-MM-YYYY") ===
                                            day.fullDate
                                          );
                                        });
                                      let disabledDay = getDisabledDay(
                                        day,
                                        atendance,
                                      );
                                      const checked =
                                        atendance && atendance.value == 1;
                                      return (
                                        <td
                                          key={dayIndex}
                                          style={{ textAlign: "center" }}
                                          className="px-1"
                                        >
                                          {category.input_type == "checkbox" ? (
                                            <Form.Check
                                              className={
                                                atendance?.confirmed_attendances ==
                                                1
                                                  ? "checked-green"
                                                  : ""
                                              }
                                              type="checkbox"
                                              id={`student-${stdIndex}-category-${catIndex}-day-${dayIndex}`}
                                              disabled={disabledDay}
                                              checked={
                                                day.nonWorking
                                                  ? false
                                                  : isAfterToday &&
                                                      classDays[day.name]
                                                    ? true
                                                    : isToday &&
                                                        !atendance &&
                                                        classDays[day.name]
                                                      ? true
                                                      : isPastDay &&
                                                          !atendance &&
                                                          classDays[day.name]
                                                        ? true
                                                        : checked
                                              }
                                              onChange={() => {
                                                let newAttendanceData = [
                                                  ...studentList,
                                                ];
                                                const attendanceExists =
                                                  newAttendanceData[
                                                    stdIndex
                                                  ].category_attendance[
                                                    catIndex
                                                  ].attendance.find((att) => {
                                                    return (
                                                      moment(att.date).format(
                                                        "ddd-DD",
                                                      ) === day.label
                                                    );
                                                  });
                                                if (attendanceExists) {
                                                  attendanceExists.value =
                                                    checked != undefined
                                                      ? !checked
                                                      : false;
                                                  setStudentList(
                                                    newAttendanceData,
                                                  );
                                                } else {
                                                  const attendance = {
                                                    category_attendance_id:
                                                      category.id,
                                                    confirmed_attendances: "0",
                                                    student_id: student.id,
                                                    value:
                                                      checked != undefined
                                                        ? !checked
                                                        : false,
                                                    date: moment(
                                                      day.fullDate,
                                                      "DD-MM-YYYY",
                                                    ).format("YYYY-MM-DD"),
                                                  };
                                                  newAttendanceData[
                                                    stdIndex
                                                  ].category_attendance[
                                                    catIndex
                                                  ].attendance.push(attendance);
                                                  setStudentList(
                                                    newAttendanceData,
                                                  );
                                                }
                                                handleAttendance(
                                                  stdIndex,
                                                  catIndex,
                                                  day.label,
                                                  checked != undefined
                                                    ? !checked
                                                    : false,
                                                  day.fullDate,
                                                );
                                              }}
                                            />
                                          ) : (
                                            <Form.Control
                                              id={`student-${stdIndex}-category-${catIndex}-day-${dayIndex}`}
                                              type="text"
                                              placeholder=""
                                              disabled={disabledDay}
                                              style={{
                                                height: "20px",
                                                fontSize: "12px",
                                                textAlign: "center",
                                              }}
                                              value={
                                                atendance ? atendance.value : ""
                                              }
                                              onChange={(e) => {
                                                let newAttendanceData = [
                                                  ...studentList,
                                                ];
                                                const attendanceExists =
                                                  newAttendanceData[
                                                    stdIndex
                                                  ].category_attendance[
                                                    catIndex
                                                  ].attendance.find((att) => {
                                                    return (
                                                      moment(att.date).format(
                                                        "ddd-DD",
                                                      ) === day.label
                                                    );
                                                  });
                                                if (attendanceExists) {
                                                  attendanceExists.value =
                                                    e.target.value;
                                                  setStudentList(
                                                    newAttendanceData,
                                                  );
                                                } else {
                                                  const attendance = {
                                                    category_attendance_id:
                                                      category.id,
                                                    confirmed_attendances: "0",
                                                    student_id: student.id,
                                                    value: e.target.value,
                                                    date: moment(
                                                      day.fullDate,
                                                      "DD-MM-YYYY",
                                                    ).format("YYYY-MM-DD"),
                                                  };
                                                  newAttendanceData[
                                                    stdIndex
                                                  ].category_attendance[
                                                    catIndex
                                                  ].attendance.push(attendance);
                                                  setStudentList(
                                                    newAttendanceData,
                                                  );
                                                }
                                                changeTextAttendance(
                                                  stdIndex,
                                                  catIndex,
                                                  day.label,
                                                  e.target.value,
                                                  day.fullDate,
                                                );
                                              }}
                                            />
                                          )}
                                        </td>
                                      );
                                    })}
                                    <td width="4%" className="hide-print">
                                      <i
                                        className="bi bi-chevron-right"
                                        style={{ color: "white" }}
                                      ></i>
                                    </td>
                                  </tr>
                                );
                              },
                            )}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  );
                })}
              {/* Lazy loading Students Lis*/}
              {updatingList && lazyLoadingStudentsList()}
            </tbody>
          </table>
        </div>
      </Col>
      {showModalDelete && (
        <ModalConfirmDelete
          showModalDelete={showModalDelete}
          title={t("class:stundentsClass.deleteStudent")}
          message={t("class:stundentsClass.deleteStudentMessage")}
          fnCancelButton={() => {
            setShowModalDelete(false);
            setStudentToDelete(null);
          }}
          fnAcceptButton={() => {
            removeStudent();
            setShowModalDelete(false);
          }}
        />
      )}
      {/* ConfirmAttendance */}
      {showModalConfirmAttendance && (
        <ModalConfirmAttendance
          classId={props.classId}
          showModalConfirmAttendance={showModalConfirmAttendance}
          onClose={() => setShowModalConfirmAttendance(false)}
          attendanceToConfirmed={attendanceToConfirmed}
          studentList={studentList}
          updateList={getAttendance}
        />
      )}
      {/* AssistanceCategories */}
      {showModalAssistanceCategories && (
        <ModalAssistanceCategories
          showModalAssistanceCategories={showModalAssistanceCategories}
          onClose={() => {
            setShowModalAssistanceCategories(false);
            extractAttendanceCategories(studentList);
          }}
          categoriesAttendance={categoriesAttendance}
          classId={props.classId}
          updateList={getAttendance}
        />
      )}
    </React.Fragment>
  );
};

export default ClassAttendance;
ClassAttendance.propTypes = {
  classId: PropTypes.string.isRequired,
  setShowModalAddStudents: PropTypes.func,
  setFieldStudents: PropTypes.func,
  setStudentsCount: PropTypes.func,
  refreshStudentList: PropTypes.bool,
  setRefreshStudentList: PropTypes.func,
  schoolCycleId: PropTypes.number,
  setCurrentStudents: PropTypes.func,
};
